import React from 'react';
import { connect } from 'react-redux';
import { Col, Form, FormGroup } from 'react-bootstrap';
import FormFields from 'containers/request/Payments/PaymentFormFields';
import SubmitPayment from 'containers/request/Payments/SubmitPayment';
import DownloadInvoice from 'containers/request/Payments/DownloadInvoice';

const PaymentForm = ({ request, history }) => {
  const submitCallback = () =>
    history.push(`/accountant/requests/${request.id}`);

  return (
    <Form horizontal>
      <FormFields />
      <hr />
      <FormGroup>
        <Col xs={12} sm={9} md={9} mdOffset={3} smOffset={3}>
          <SubmitPayment submitCallback={submitCallback} />
          <DownloadInvoice />
        </Col>
      </FormGroup>
    </Form>
  );
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(PaymentForm);



// WEBPACK FOOTER //
// ./src/containers/request/Payments/PaymentFormAccountant.js